export const AWARENESS_POINTER_MOVE_THROTTLE_INTERVAL = 100;

export const AWARENESS_SCROLL_DEBOUNCE_INTERVAL = 100;

export const AWARENESS_POINTER_HIDE_TIMEOUT = 3000;
